import presets from '../../json/animationPresets';
import { gsap } from "gsap";
// import {CountUp} from "countup.js";
// import lottie from 'lottie-web';

export default class ScrollAnimations {
  constructor(ctrl) {
    this.controller = ctrl;
  }

  init() {
    let self = this;

    $('[data-anim]').each(function(index, elem) {

      let $el = $(this),
        animation = $el.data('anim'),
        animation_from = undefined,
        animation_to = $el.data('anim-to'),
        animation_duration = $el.data('anim-dur'),
        animation_delay = $el.data('anim-delay'),
        trigger_hook = $el.data('anim-trigger'),
        lottie_anim = $el.data('lottie'),
        countup = undefined;

      let preset = animation && presets.hasOwnProperty(animation) ? presets[animation] : null;

      !preset ? animation_from = animation : false;

      if(animation === "countUp") {
        countup = prepareCountUp(elem);
      }

      if(lottie_anim !== undefined) {
        let data = lottie_anim.valueOf();

        lottie_anim = lottie.loadAnimation({
          container: elem,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: data
        });
      }

      if(preset) {
        if(animation_from === undefined) animation_from = Object.assign({}, preset.from);
        if(animation_to === undefined) animation_to = Object.assign({}, preset.to);
        if(animation_duration === undefined) animation_duration = preset.duration.valueOf();
      }

      if (animation_duration === undefined && !preset) {
        animation_duration = 1;
      }

      if (trigger_hook === undefined) {
        trigger_hook = 1;
      }

      if(animation_delay) {
        animation_to.delay = animation_delay;
      }

      if(animation_to.ease === undefined) {
        animation_to.ease = "Power3.easeOut";
      }


      let tween = gsap.timeline();

      gsap.set($el, animation_from);

      animation_to.force3D = true;

      animation_to.duration = animation_duration;

      if(lottie_anim) {
        tween.to(elem, {
          duration: animation_duration,
          onComplete: () => {
            lottie_anim && lottie_anim.play();
          }
        })
      } else {
        tween.to(elem, animation_to);
      }

      tween.eventCallback("onComplete", () => {
        $el.removeAttr( 'style' );

        if(countup) {
          countup && countup.start();
        }
      });

      new ScrollMagic.Scene({
        triggerElement: elem,
        triggerHook: trigger_hook
      })
        .setTween(tween)
        .addTo(self.controller)
        .reverse(false);
    });

    function prepareCountUp(elem) {
      const easingFn = function(t, b, c, d) {
        let ts = (t /= d) * t;
        let tc = ts * t;
        return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
      };

      const options = {
        startVal: 1,
        duration: 1.5,
        separator: '',
        easingFn: easingFn
      };

      let num = $(elem).html().split(" ")[0].replace(/\./g, "");
      return new CountUp(elem, parseInt(num), options);
    }
  }
};


// WEBPACK FOOTER //
// ./static/js/components/OnScrollAnim.js